/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { VIEW_TYPES } from 'components/common/view-type/settings'
import { BUSINESS_LINES_TABS } from 'containers/pricing/common/settings'
import { get } from 'utils/lodash'

const { LIST } = VIEW_TYPES

const initialState = {
  viewType: LIST,
  hideArchived: false,
  businessLine: BUSINESS_LINES_TABS.ALL_BUSINESS_LINES,
}

const disposalFeesSlice = createSlice({
  name: 'persistentDisposalFees',
  initialState: { ...initialState },
  reducers: {
    setViewType: (state, action) => {
      state.viewType = action.payload
    },
    setHideArchivedDisposalFees: (state, action) => {
      state.hideArchived = action.payload
    },
    setSelectedDisposalFeesBusinessLine: (state, action) => {
      state.businessLine = action.payload
    },
  },
})

export const { setViewType, setHideArchivedDisposalFees, setSelectedDisposalFeesBusinessLine } = disposalFeesSlice.actions

export const selectViewType = state => get(state, 'persistentDisposalFees.viewType', LIST)

export const selectHideArchivedDisposalFees = s => get(s, 'persistentDisposalFees.hideArchived')

export const selectSelectedDisposalFeesBusinessLine = s =>
  get(s, 'persistentDisposalFees.businessLine', BUSINESS_LINES_TABS.ALL_BUSINESS_LINES)

export default disposalFeesSlice.reducer
